import { Component, Input } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { PrinterService } from '../../providers/printglobal/printer.service';
import { CajaProvider } from '../../providers/caja/caja'
import { Storage } from '@ionic/storage'
import { NUBE_AWS } from '../../config/url.servicio';

@Component({
  selector: 'imprimir-global',
  templateUrl: 'imprimir-global.html',
  providers: [ PrinterService,CajaProvider ]
})
export class ImprimirGlobalComponent {
  printerList: any[];
  textToPrint: any = ''
  selectedPrinter:any = ''
  cantidadImpresionesEnCaja:any= "1"
  queHago:any = ""
  ip:string = ""
  cufe:string = ""
  constructor(private viewCtrl: ViewController, private navParams: NavParams,
    private printerService: PrinterService,
    public servicio: CajaProvider,
    private storage: Storage,

  ) {
    this.textToPrint = this.navParams.get('text');
    this.cufe = this.navParams.get('cufe')
    this.queHago = this.navParams.get('queHago');
    this.cantidadImpresionesEnCaja = this.navParams.get('cantidadImpresionesEnCaja');
    this.ip = this.navParams.get('ip');
    if(this.queHago === 'imprimirMesero') {
      this.imprimirMesero(this.textToPrint)
      this.viewCtrl.dismiss(this.selectedPrinter);
      return
    }
    this.loadPrinterList()
  }

  selectFormaPago(item: any) {
    this.viewCtrl.dismiss(item);
  }



    // Cargar la lista de impresoras disponibles
    async loadPrinterList() {
      this.printerList = await this.printerService.getPrinters(this.ip).toPromise();
    }

    // Imprimir el texto utilizando la impresora seleccionada
    async imprimirTexto(nombreImpresora:any = undefined) {
      this.selectedPrinter = nombreImpresora === undefined ? this.selectedPrinter : nombreImpresora
      if (this.selectedPrinter && this.textToPrint) {
        try {
          this.printerService.printText(this.selectedPrinter, this.textToPrint,this.ip, this.cufe).subscribe((data)=>{
            console.log('Texto enviado a imprimir:', data);
          },(error)=>{
            console.log(error)
          })

        } catch (error) {
          console.error('Error al imprimir texto:', error);
        }
      } else {
        console.error('Debe seleccionar una impresora y proporcionar texto para imprimir.');
      }
    }

   async onPrinterChange(event) {
      this.selectedPrinter = event;
      if(this.queHago === 'imprimirFacturadia') {
        this.imprimirFacturadiaReemprimirGlobal(this.textToPrint['factura'])
        this.viewCtrl.dismiss(this.selectedPrinter);
        return
      }
      if(this.queHago === 'imprimirMesero') {
        this.imprimirMesero(this.textToPrint)
        this.viewCtrl.dismiss(this.selectedPrinter);
        return
      }
      if(this.queHago === 'imprimirMeseroTodaLaFactura') {
        this.imprimirMeseroTodaLaFactura(this.textToPrint)
        this.viewCtrl.dismiss(this.selectedPrinter);
        return
      }
      if(this.queHago === 'devolverNombreImpresora') {
        this.viewCtrl.dismiss(this.selectedPrinter);
        return
      }



    }

    imprimirFacturadiaReemprimirGlobal(codigo:any){


        this.storage.get('companiasId').then((val) => {
          let factura:number
          factura = Number(codigo)

          this.servicio.buscarVentasDiarias(factura,val)
          .subscribe((data)=>{
            let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
            if(this.cantidadImpresionesEnCaja == undefined) {
              this.cantidadImpresionesEnCaja = "1"
            }
            for(var i = 1; i <= parseInt(this.cantidadImpresionesEnCaja,10); i++){
              this.reemprimirReciboDia(response)
            }

          },
          error=>{
            console.log(error)
          })
        })

  }

  async reemprimirReciboDia(mensaje) {
    let recibo = ''

  for (let index:any = 0; index < mensaje.length; index++) {
    recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
  }
  recibo +=  '   '  + '\n'
  this.textToPrint = recibo
  await this.imprimirTexto()
  }

  imprimirMesero(values: string) {

    this.storage.get('companiasId').then((val) => {
      this.servicio.imprimirComandasMesasPorGestionMultiplesImpresoras(values, val)
        .subscribe((data) => {
          let dataJson = JSON.parse(data['_body'])
          let responseJson = dataJson
          this.reemprimirReciboMesasGestion(responseJson.data,undefined)
        },
          error => {
            console.log(error)
          })
    })
  }


  async reemprimirReciboMesasGestion(valorImpresora:any,nombreImpresora:string) {

    for (let posicion: any = 0; posicion < valorImpresora.length; posicion++) {

      let recibo = ''
      // if (mensaje && mensaje[0] && mensaje[0][0]) {
        const mensajes = valorImpresora[posicion]
        let nombreImpresora = undefined
        for (let index: any = 0; index < mensajes.length; index++) {
          if(index + 1 == mensajes.length ) {
            nombreImpresora = mensajes[index]['reciboCaja']
          } else {
            recibo += mensajes[index]['reciboCaja'] + '\n'
          }
        }

        recibo +=  '   '  + '\n'
        recibo +=  '   '  + '\n'
        recibo +=  '   '  + '\n'
       this.textToPrint = recibo
       if(nombreImpresora !== undefined) {
        await this.imprimirTexto(nombreImpresora)
       }

    }

  }


  imprimirMeseroTodaLaFactura(values: string) {

    this.storage.get('companiasId').then((val) => {
      this.servicio.imprimirComandaBlueRed(values, val)
        .subscribe((data) => {
          let dataJson = JSON.parse(data['_body'])
          let responseJson = dataJson
          this.reemprimirReciboMesasGestionPorImpresora(responseJson.data, this.selectedPrinter)
        },
          error => {
            console.log(error)
          })
    })
  }

  async reemprimirReciboMesasGestionPorImpresora(valorImpresora:any,nombreImpresora:string) {

    for (let posicion: any = 0; posicion < valorImpresora.length; posicion++) {

      let recibo = ''
      // if (mensaje && mensaje[0] && mensaje[0][0]) {
        const mensajes = valorImpresora[posicion]

        for (let index: any = 0; index < mensajes.length; index++) {
         recibo += mensajes[index]['reciboCaja'] + '\n'
        }

        recibo +=  '   '  + '\n'
        recibo +=  '   '  + '\n'
        recibo +=  '   '  + '\n'
       this.textToPrint = recibo
       if(nombreImpresora !== undefined) {
        await this.imprimirTexto(nombreImpresora)
       }

    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/imprimir-global/imprimir-global.ts